import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const paginateEmailTemplates = {
  name: "paginateEmailTemplates" as const,
  input: z.object({
    teamId: zExt.objectId().optional(),
    limit: z.number().positive().optional(),
    searchText: z.string().optional(),
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
  }),
  output: z.object({
    data: z.array(emailTemplateSchema),
    totalCount: z.number().optional(),
  }),
};
